import {GeneralSettingType} from "../types/GeneralSettingType";

export const CompanySetInitialState = () => {
    let company_settings : Array<GeneralSettingType> = []

    const companySettingsSavedObject = localStorage.getItem('company_settings');

    if(companySettingsSavedObject) {
        company_settings = JSON.parse(companySettingsSavedObject);
    }

    return company_settings;
}